import { PageLayout } from "@/components/page-layout/PageLayout";
import { CustomerInfoPairBox } from "@/features/product-and-price/info-boxes/customer/CustomerInfoPairBox";
import {
  CreateHeadAgreementFetcherQuery,
  CreateHeadAgreementFetcherQueryVariables,
} from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";
import { BreadCrumbs } from "@stenajs-webui/elements";
import { ErrorScreen, LoadingScreen } from "@stenajs-webui/panels";
import * as React from "react";
import { routeFactory } from "../../../../../RouteFactory";
import { Crumb } from "@/components/bread-crumbs/Crumb";
import { PageHeader } from "@/components/page-header/PageHeader";
import { useNegotiationYears } from "../../../../../contexts/NegotiationYearGate";
import { CreateHeadAgreementPanel } from "./CreateHeadAgreementPanel";

interface Props {
  customerId: string;
}

const query = gql`
  query CreateHeadAgreementFetcher($customerId: ID!) {
    productPrice {
      customers {
        byId(id: $customerId) {
          id
          name
          breadCrumbName
          custIndex
          custNo
          isParent
          preselectedHeadAgreement {
            id
          }
          custStatus {
            id
            name
          }
          parent {
            id
            preselectedHeadAgreement {
              id
            }
          }
          childCustomers {
            id
          }
          statisticalGrouping {
            id
          }
          invoiceCurrency {
            id
            code
          }
          seller {
            id
            name
          }
          salesRegion {
            id
            code
            name
          }
          isStandardCustomer
          hasRebateAgreements
          writeHistory {
            createdAt {
              isoString
            }
            createdBy {
              id
              name
            }
            modifiedAt {
              isoString
            }
            modifiedBy {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const CreateHeadAgreement: React.FC<Props> = ({ customerId }) => {
  const { defaultYear } = useNegotiationYears();
  const { data, error, loading } = useQuery<
    CreateHeadAgreementFetcherQuery,
    CreateHeadAgreementFetcherQueryVariables
  >(query, {
    variables: {
      customerId,
    },
  });

  const customer = data?.productPrice.customers.byId;

  return (
    <>
      <PageHeader
        title={"Create header agreement"}
        breadcrumbs={
          <BreadCrumbs>
            <Crumb
              label={customer?.breadCrumbName ?? ""}
              path={routeFactory.productAndPrice.customer.customer({
                customerId,
              })}
            />
            <Crumb
              path={routeFactory.productAndPrice.headAgreement.createHeadAgreement(
                {
                  customerId,
                }
              )}
              label={"create"}
            />
          </BreadCrumbs>
        }
      />

      {error ? (
        <ErrorScreen text={"No such customer."} />
      ) : loading ? (
        <LoadingScreen />
      ) : (
        <PageLayout>
          {customer && <CustomerInfoPairBox customer={customer} />}
          <CreateHeadAgreementPanel
            customerId={customerId}
            nameProposal={
              customer ? `${customer.custIndex}.${defaultYear}` : undefined
            }
          />
        </PageLayout>
      )}
    </>
  );
};
